
import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Autocomplete } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FormField from "layouts/applications/wizard/components/FormField";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { MODULE_MASTER } from "utils/constant";
import { useParams } from "react-router-dom";

const EditCampaign = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [statusType, setStatusType] = useState([]);
    const [statusEntity, setStatusEntity] = useState([]);
    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });
    const [description, setDescription] = useState({
        text: "",
        error: false,
        textError: "",
    });
    //   const []

    useEffect(() => {
        (async () => {
            try {
                const response = await CrudService.getStatusTypes(MODULE_MASTER.ENTITIES);
                setStatusEntity(response.data);
                setStatusType(response.default_id);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
    }, [])

    useEffect(() => {
        if(!id) return
        (async () => {
            try {
                const response = await CrudService.getCampaign(id);
                setName({...name, text: response.data.name});
                setDescription({...description, text: response.data.description});
                let status = {...response.data.statusType, id: response.data.statusType.status_type_id}
                setStatusType(status);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
    }, [id])

    const submitHandler = async (e) => {
        e.preventDefault();

        // const formattedCompany = company.map((element) => element.attributes);
        const data = {
            name: name.text,
            description: description.text,
            status_type_id: statusType.id
        };
        try {
            await CrudService.updateCampaign(id, data);
            navigate("/campaign", {
                state: { value: true, text: "The campaign was successfully updated" },
            });
        } catch (err) {
            if (err.hasOwnProperty("msg")) {
                setName({ ...name, error: true, textError: err.msg });
            }
            console.error(err);
        }
    };

    const isOptionEqualToValueEntityStatus = (option, value) => {
        return option.attributes?.StatusType.status_name === value.attributes?.StatusType.status_name;
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Add New Campaign
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox component="form" method="POST" onSubmit={submitHandler}>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    <FormField
                                        required
                                        type="text"
                                        label="Name"
                                        name="name"
                                        value={name.text}
                                        error={name.error}
                                        onChange={(e) => setName({ ...name, text: e.target.value })}
                                    />
                                    {name.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {name.textError}
                                        </MDTypography>
                                    )}
                                    <FormField
                                        required
                                        type="text"
                                        label="Description"
                                        name="description"
                                        value={description.text}
                                        error={description.error}
                                        onChange={(e) => setDescription({ ...description, text: e.target.value })}
                                    />
                                    {description.error && (
                                        <MDTypography variant="caption" color="error" fontWeight="light">
                                            {description.textError}
                                        </MDTypography>
                                    )}

                                    <Autocomplete
                                        defaultValue=""
                                        options={statusEntity}
                                        getOptionLabel={(option) => (option.attributes ? option.attributes?.StatusType.status_name : "")}
                                        value={statusType ?? null}
                                        onChange={(event, newStatus) => {
                                            setStatusType(newStatus);
                                        }}
                                        isOptionEqualToValue={isOptionEqualToValueEntityStatus} // Custom equality function
                                        renderInput={(params) => (
                                            <FormField {...params} label="Status" InputLabelProps={{ shrink: true }} required />
                                        )}
                                    />

                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() =>
                                                    navigate("/campaign", {
                                                        state: { value: false, text: "" },
                                                    })
                                                }
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit">
                                            Update
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default EditCampaign;
